import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import type { ResourcesConfig } from 'aws-amplify';
import { LoadScript } from '@react-google-maps/api';
import ThemeWrapper from 'theme/ThemeWrapper';
import { RedirectLayer } from 'components/Shared/RedirectLayer';
import ErrorBoundary from './ErrorBoundary';
import { store } from './redux/store';
import RoutesPage from './routes';
import amplifyConfig from './aws-exports';
import { sentryInitialization } from './configs/sentry.config';

Amplify.configure(amplifyConfig as ResourcesConfig);
const googleMapApiKey = process.env.REACT_APP_GOOGLE_PLACES_API_KEY || '';
if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  sentryInitialization();
}

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <ThemeWrapper>
          <ErrorBoundary>
            <RedirectLayer>
              {/* LoadScript requires valid API key - skip when empty to prevent app crash */}
              {googleMapApiKey ? (
                <LoadScript
                  googleMapsApiKey={googleMapApiKey}
                  libraries={['places']}
                  language="en"
                >
                  <RoutesPage />
                </LoadScript>
              ) : (
                <RoutesPage />
              )}
            </RedirectLayer>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
